import './List.less';
import { useState } from 'react';
import {
  Row,
  Col,
  Divider,
  Grid,
  Modal,
  Typography,
  //  Drawer, Button
} from 'antd';
const { Link } = Typography;
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import EditIcon from 'assets/images/liHome/account-edit.svg';
import profile from 'assets/images/liHome/Profile.svg';
import markCircle from 'assets/images/liHome/mark-circle.svg';
import AddPolicy from 'assets/images/liHome/Add-policy.svg';
import password from 'assets/images/liHome/password.svg';
import Information from 'assets/images/liHome/Personal-Information.svg';
import Privacy from 'assets/images/liHome/Privacy-Policy.svg';
import Close from 'assets/images/liHome/close.svg';
// import Photo from 'assets/images/liHome/photo.svg';
// import File from 'assets/images/liHome/file.svg';
import ChangeAvatar from './ChangeAvatar';
import ImgCropComponent from './ImgCrop';
import { useNavigate } from 'react-router-dom';
import { Root } from 'all-in-one-shared-api/dist/apis/profile/useLifeUserProfile';
// import {
//   useLifeProfileImage,
//   useLifeProfileImageUpdate,
//   // useLogLogout,
//   // useSWRConfig,
//   // useLifeUserProfile,
// } from 'all-in-one-shared-api';
// import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { isLocaleEnglish } from 'utils/languageUtils';
const { useBreakpoint } = Grid;

interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  background: #fff;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 16px;
`;
const FlexCol = styled(Col)<{ flag?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: ${(props) => (props.flag ? '0 16px' : '0')};
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const DividerLine = ({ padB }: DividerLineProps) => {
  return (
    <Androw justify="start" padB={padB}>
      <AndCol style={{ width: '100%' }}>
        <AntDivider style={{ margin: '12px 0' }}></AntDivider>
      </AndCol>
    </Androw>
  );
};
const AccountList = (props: { sendStatus: () => void; profile?: Root }) => {
  const { t, i18n } = useTranslation();
  const { xs } = useBreakpoint();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEnglish = isLocaleEnglish(i18n.language);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  // const showDrawer = () => {
  //   setOpen(true);
  // };

  // const onClose = () => {
  //   setOpen(false);
  // };
  const handlePic = () => {
    //换头像
    if (!xs) {
      //网页
      showModal();
      // } else {
      //移动端
      // showDrawer();
    }
  };
  // const openLibrary = () => {
  //   //
  //   showModal();
  // };
  const changePass = () => {
    //换密码
    navigate('/changePwd', {
      state: {
        loginId: props.profile?.loginId,
        mobile: props.profile?.mobile,
        email: props.profile?.email,
        countryCode: props.profile?.countryCode,
        areaCode: props.profile?.areaCode,
      },
    });
  };
  const addEbPolicy = () => {
    //addeb
    navigate('/ProfileConnectEb');
  };
  const forceupAvatar = () => {
    props.sendStatus();
  };
  return (
    <>
      <div className="account_list_container">
        <StyledBlock className="account-detail">
          <Androw justify="start" paddingFlag="16px">
            <AndCol className="font-size26 grey-font">{t('life.lifeProfile.PersonalInfo')}</AndCol>
            <AntDivider style={{ margin: '12px 0' }}></AntDivider>
          </Androw>
          <Androw justify="space-between" className="pointer" onClick={handlePic}>
            <AndCol span={18}>
              <Androw justify="start">
                <FlexCol>
                  <img src={profile} alt="" />
                  {!xs && (
                    <span className="font-size20" style={{ marginLeft: '12px' }}>
                      {t('life.lifeProfile.ProfilePic')}
                    </span>
                  )}
                  {xs && <ImgCropComponent sendAvatarStatus={forceupAvatar}></ImgCropComponent>}
                </FlexCol>
              </Androw>
            </AndCol>
            <FlexCol span={1} flag>
              <img src={EditIcon} alt="" style={{ float: 'right' }} />
            </FlexCol>
          </Androw>
          <DividerLine></DividerLine>
          <Androw justify="space-between" className="pointer" onClick={changePass}>
            <AndCol span={18}>
              <Androw justify="start">
                <FlexCol>
                  <img src={password} alt="" />
                  <span className="font-size20" style={{ marginLeft: '12px' }}>
                    {t('life.lifeProfile.changePassword')}
                  </span>
                </FlexCol>
              </Androw>
            </AndCol>
            <FlexCol span={1} flag>
              <img src={EditIcon} alt="" style={{ float: 'right' }} />
            </FlexCol>
          </Androw>
          <DividerLine></DividerLine>
        </StyledBlock>
        {props.profile?.showIndicator == 'Y' && (
          <StyledBlock className="account-detail">
            <Androw justify="start" paddingFlag="16px">
              <AndCol className="font-size26 grey-font ">{t('life.lifeProfile.OtherSettings')}</AndCol>
              <AntDivider style={{ margin: '16px 0' }}></AntDivider>
            </Androw>
            <Androw justify="space-between" className="pointer" onClick={addEbPolicy}>
              <AndCol span={18}>
                <Androw justify="start">
                  <FlexCol>
                    <img src={AddPolicy} alt="" />
                    <span className="font-size20" style={{ marginLeft: '12px' }}>
                      {t('life.lifeProfile.addEb')}
                    </span>
                  </FlexCol>
                </Androw>
              </AndCol>
              <FlexCol span={1} flag>
                <img src={ChevronRight} alt="" style={{ float: 'right' }} />
              </FlexCol>
            </Androw>
            <DividerLine></DividerLine>
          </StyledBlock>
        )}
        <StyledBlock className="account-detail">
          <Androw justify="start" paddingFlag="16px">
            <AndCol className="font-size26 grey-font ">{t('life.lifeProfile.importantInfo')}</AndCol>
            <AntDivider style={{ margin: '12px 0' }}></AntDivider>
          </Androw>
          <Link
            className="to-other"
            href={
              isEnglish
                ? 'https://www.generali.com.hk/EN_US/legal_information'
                : 'https://www.generali.com.hk/ZH_HK/legal_information'
            }
          >
            <Androw justify="space-between" className="pointer">
              <AndCol span={18}>
                <Androw justify="start">
                  <FlexCol>
                    <img src={markCircle} alt="" />
                    <span className="font-size20" style={{ marginLeft: '12px' }}>
                      {t('life.lifeProfile.legalInformation')}
                    </span>
                  </FlexCol>
                </Androw>
              </AndCol>
              <FlexCol span={1} flag>
                <img src={ChevronRight} alt="" />
              </FlexCol>
            </Androw>
          </Link>

          <DividerLine></DividerLine>
          <Link
            className="to-other"
            href={
              isEnglish
                ? 'https://www.generali.com.hk/EN_US/privacy_security_cookies'
                : 'https://www.generali.com.hk/ZH_HK/privacy_security_cookies'
            }
          >
            <Androw justify="space-between">
              <AndCol span={18}>
                <Androw justify="start" className="pointer">
                  <FlexCol>
                    <img src={Privacy} alt="" />
                    <span className="font-size20" style={{ marginLeft: '12px' }}>
                      {t('life.lifeProfile.PrivacyPolicy')}
                    </span>
                  </FlexCol>
                </Androw>
              </AndCol>
              <FlexCol span={1} flag>
                <img src={ChevronRight} alt="" />
              </FlexCol>
            </Androw>
          </Link>

          <DividerLine></DividerLine>
          <Link
            className="to-other"
            href={
              isEnglish
                ? 'https://www.generali.com.hk/EN_US/personal_information'
                : 'https://www.generali.com.hk/ZH_HK/personal_information'
            }
          >
            <Androw justify="space-between">
              <AndCol span={18}>
                <Androw justify="start" className="pointer">
                  <FlexCol>
                    <img src={Information} alt="" />
                    <span className="font-size20" style={{ marginLeft: '12px' }}>
                      {t('life.lifeProfile.collectionState')}
                    </span>
                  </FlexCol>
                </Androw>
              </AndCol>
              <FlexCol span={1} flag>
                <img src={ChevronRight} alt="" />
              </FlexCol>
            </Androw>
          </Link>

          <DividerLine></DividerLine>
        </StyledBlock>
      </div>
      <Modal
        title={t('life.lifeProfile.changeProfilePicture')}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        className="upload-img"
        closeIcon={<img src={Close} />}
        width={510}
      >
        <ChangeAvatar sendAvatarStatus={forceupAvatar} sendModalStatus={handleCancel}></ChangeAvatar>
      </Modal>
      {/* 
      //适配平板端下拉弹窗
      <Drawer
        title="Drawer with extra actions"
        headerStyle={{ display: 'none' }}
        placement="bottom"
        width="100%"
        height={250}
        closable={false}
        open={open}
        className="drawer-select"
      >
        <div className="button-choose">
          <p className="choose-title">{t('life.lifeProfile.SelectPhoto')}</p>
          <p className="choose-btn" onClick={openLibrary}>
            <img src={Photo} alt="" />
            {t('life.lifeProfile.photoLibrary')}
          </p>
          <p className="choose-btn">
            <img src={File} alt="" />
            {t('life.lifeProfile.Camera')}
          </p>
        </div>
        <div className="button-cancel">
          <Button onClick={onClose}>{t('life.lifeProfile.Cancel')}</Button>
        </div>
      </Drawer> */}
    </>
  );
};
export default AccountList;
